/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerRightUp = createReactComponent("outline", "corner-right-up", "IconCornerRightUp", [["path", { "d": "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4", "key": "svg-0" }]]);

export { IconCornerRightUp as default };
//# sourceMappingURL=IconCornerRightUp.mjs.map
